export const BASE_URL = process.env.REACT_APP_BASE_URL + 'api/'
export const SITE_URL = process.env.REACT_APP_BASE_URL + 'api/'
export const IMAGE_URL = process.env.REACT_APP_BASE_URL + 'storage/'
export const API_URL = BASE_URL + 'v1/'
